import { render, staticRenderFns } from "./ProcessCreateOrderDocumentationOverviewImage.vue?vue&type=template&id=9fd94e98&scoped=true"
import script from "./ProcessCreateOrderDocumentationOverviewImage.vue?vue&type=script&lang=js"
export * from "./ProcessCreateOrderDocumentationOverviewImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fd94e98",
  null
  
)

export default component.exports